var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCellWarningHint = function SvgCellWarningHint(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#ffffff",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.72506 17.4996H16.2751C17.5584 17.4996 18.3584 16.1079 17.7167 14.9996L11.4417 4.15791C10.8001 3.04958 9.20006 3.04958 8.55839 4.15791L2.28339 14.9996C1.64173 16.1079 2.44173 17.4996 3.72506 17.4996ZM10.0001 11.6662C9.54179 11.6662 9.16679 11.2912 9.16679 10.8328V9.16618C9.16679 8.70785 9.54179 8.33285 10.0001 8.33285C10.4585 8.33285 10.8335 8.70785 10.8335 9.16618V10.8328C10.8335 11.2912 10.4585 11.6662 10.0001 11.6662ZM9.16679 14.9995H10.8335V13.3328H9.16679V14.9995Z",
    fill: "#DB973A"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCellWarningHint, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cell_warning_hint.f98fe2d9.svg";
export { ForwardRef as ReactComponent };